export default class Navigation {
	constructor(carousel, options) {
		this.carousel = carousel
		this.nextButton = carousel.element.parentNode.querySelector(options.nextSelector) || carousel.element.parentNode.querySelector('.o-carousel__button--next');
		this.previousButton = carousel.element.parentNode.querySelector(options.previousSelector) || carousel.element.parentNode.querySelector('.o-carousel__button--previous');
	}

	init() {
		this.next()
		this.previous()
		this.updateButton()

		this.carousel.on( 'select', () => {
			this.updateButton()
		});
	}

	previous() {
		this.previousButton.addEventListener('click', () => {
			this.carousel.previous();
			this.updateButton()
        });
	}

	next() {
		this.nextButton.addEventListener('click', () => {
			this.carousel.next();
			this.updateButton()
        });
	}

	updateButton() {
		if (this.carousel.selectedIndex >= (this.carousel.slides.length - 1)) {
			this.nextButton.disabled = true;
		} else if (this.carousel.selectedIndex == 0) {
			this.previousButton.disabled = true;
		} else {
			this.nextButton.disabled = false;
			this.previousButton.disabled = false;
		}
	}
}



// WEBPACK FOOTER //
// ./js/modules/carousel/carousel.navigation.js